import { PhysicalStore, Product } from '../../constants/apis';
import type { PhysicalStoreDetails, ProductAdditionalInfoResponse } from '../../types/product';
import { ApiManager } from '../axios-config';

export const getProductDetails = async ({
  id,
  imagesCount,
  storesCount,
}: {
  id: string;
  imagesCount?: number;
  storesCount?: number;
}) => {
  const productAdditionalInfoUrl = new URL(`${Product}/additional-info/${id}`);
  const params = new URLSearchParams({});

  if (imagesCount) {
    params.append('imagesCount', `${imagesCount}`);
  }

  if (storesCount) {
    params.append('storesCount', `${storesCount}`);
  }

  productAdditionalInfoUrl.search = params.toString();

  return await ApiManager.get<ProductAdditionalInfoResponse>(productAdditionalInfoUrl.toString());
};

export const getPhysicalProductDetailsByClick = async (params: {
  id: string;
  storeId: string;
  sessionId: string;
  isHybridStore: boolean;
}) => {
  return await ApiManager.get<PhysicalStoreDetails>(`${PhysicalStore}/${params.id}/click`, { params });
};
